export const ACTIONS_SELECTOR = 'crm-card-actions';
export const CONTENT_SELECTOR = 'crm-card-content';
export const TITLE_SELECTOR = 'crm-card-title';